module.exports = __webpack_public_path__ + "img/logo_new@2x.3e4d1a7b.png";